import React, { useEffect, useRef, useState } from "react";
import { Button, Container, Card, Modal, Form } from "react-bootstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import $ from "jquery";
import "bootstrap/dist/css/bootstrap.min.css";
import "datatables.net-bs5/css/dataTables.bootstrap5.min.css";
import "datatables.net-responsive-bs5/css/responsive.bootstrap5.min.css";
import "datatables.net-bs5";
import "datatables.net-responsive-bs5";
import * as XLSX from "xlsx";
import Header from "../Header";

const UserQueries = () => {
  const tableRef = useRef(null);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedRequest, setSelectedRequest] = useState(null);
  const [user_Description, setUserRemarks] = useState('');
  const [selectedFiles, setSelectedFiles] = useState([]);  // Changed to an array to handle multiple files
  const [successMessage, setSuccessMessage] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const id = localStorage.getItem('userId');
  const sessionName = localStorage.getItem('userName');
  
  // Fetch data
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          `https://apiaksharaconnect.aksharafinalytics.in/userquerylist/${id}`
        );
        if (!response.ok) throw new Error("Network response was not ok");

        const result = await response.json();
       
        setData(result.userquerylist || []);
      } catch (error) {
        console.error("Error fetching data:", error);
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  
  // Initialize DataTable
  useEffect(() => {
    if (tableRef.current && data.length > 0) {
      const table = $(tableRef.current).DataTable({
        responsive: true,
        autoWidth: false,
        destroy: true,
        paging: true,
        pageLength: 10,
        lengthMenu: [10, 25, 50, 100],
        columnDefs: [
          { targets: 0, responsivePriority: 1 },
          { targets: 1, responsivePriority: 2 },
          { targets: 2, responsivePriority: 3 },
          { targets: 3, responsivePriority: 4 },
        ],
      });

      return () => {
        table.destroy();
      };
    }
  }, [data]);

  // Export to Excel
  const exportToExcel = () => {
    if (data.length === 0) {
      alert("No data to export!");
      return;
    }
    const ws = XLSX.utils.json_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "data");
    XLSX.writeFile(wb, "data_List.xlsx");
  };

  // Open modal for reply
  const openModal = (request) => {
    setSelectedRequest(request);
    //console.log(request);
    setIsModalOpen(true);
  };

  // Handle form submit (reply with remarks and multiple files)
  const handleFormSubmit = async (e) => {
    e.preventDefault();

    const recordId = selectedRequest.ID;
    const emp_id = selectedRequest.emp_id;
    const service_task_id = selectedRequest.Service_task === 'Others' 
    ? selectedRequest.other_service_task 
    : selectedRequest.Service_task;
    const emp_query = selectedRequest.emp_query;
    
    setIsSubmitting(true); 

    const formData = new FormData();
    formData.append("user_Description", user_Description); 
    formData.append("user_id", id); 
    formData.append("emp_id", emp_id); 
    formData.append("username", sessionName); 
    formData.append("service_task_id", service_task_id); 
    formData.append("emp_query", emp_query); 

    for (let i = 0; i < selectedFiles.length; i++) {
        formData.append('files[]', selectedFiles[i]);
    }

    console.log('FormData being sent:');
    for (let pair of formData.entries()) {
        console.log(`${pair[0]}:`, pair[1]);
    }
    
    try {
        // Make the POST request to the server
        const response = await fetch(`https://apiaksharaconnect.aksharafinalytics.in/updatetask/${recordId}`, {
            method: 'POST',
            body: formData,
        });
        const res = await response.json();        
        
        if (res.status === 'success') {
            setUserRemarks(''); // Reset remarks input
            setSelectedFiles([]); // Reset file inputs
            setIsModalOpen(false); // Close modal after successful submission
            setTimeout(() => {
              setSuccessMessage(res.message);
              window.location.reload();
            }, 5000);
        } else {
            // Handle error based on response
            setError(res.message);
            console.error('Error message from server:', res.message);
        }
    } catch (error) {
        setError('An error occurred while uploading the files.'); // Handle general errors
        console.error('Error during fetch:', error); // Log the error to console for debugging
    } finally {
        setIsSubmitting(false);  // Stop submission process
    }
};


  if (loading) return <div className="text-center mt-4">Loading...</div>;

  return (
    <>
      <Header />
      <Container fluid className="mt-4">
        <Card className="shadow">
          <Card.Header className="d-flex justify-content-between align-items-center">
            <h4>Queries</h4>
            <Button variant="success" onClick={exportToExcel}>
              Export to Excel
            </Button>
          </Card.Header>
          <Card.Body>
            {error && <div className="alert alert-danger">{error}</div>}
            {successMessage && <div className="alert alert-success">{successMessage}</div>}

            <div className="table-responsive">
              <table ref={tableRef} className="table table-striped table-bordered display nowrap" style={{ width: "100%" }}>
                <thead>
                  <tr>
                    <th>S.no</th>
                   <th>Task id</th> 
                   <th>Service Task</th>
                    <th>Query</th>
                    <th>Description</th>
                    <th>Documents</th>
                    <th>Action</th>
                    <th>Raised On</th>
                    <th>Closed On</th>
                  </tr>
                </thead>
                <tbody>
                  {data?.length > 0 ? (
                    data.map((data, index) => (
                      <tr key={`${data.id}-${index}`}>
                        <td>{index + 1}</td>
                        <td>{data.task_uniqueid || "N/A"}</td> 
                        <td>{data.Service_task === 'Others' ? (
                         data.other_service_task
                        ) : (
                          data.Service_task
                        )}                      
                      </td>
                        <td>{data.emp_query || "N/A"}</td>
                        <td>{data.user_Description || "N/A"}</td>
                        <td>
                          {data.file_path ? (
                            <a href={`https://apiaksharaconnect.aksharafinalytics.in/${data.file_path}`} download={data.file_path || 'N/A'} target="_blank">
                              <Button variant="warning" className="ms-2 p-1 m-1">
                                <FontAwesomeIcon icon={faDownload} />
                                 Documents
                              </Button>
                            </a>
                          ) : (
                            <span>N/A</span>
                          )}
                        </td>                   
                        <td> 
                            <Button variant="primary" onClick={() => openModal(data)}   disabled={data.status === "close" || data.user_Description !== null}> Reply</Button>
                        </td>
                        <td>{data.doa || "N/A"}</td>  
                        <td>{data.task_cdate || "N/A"}</td>     
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="9" className="text-center">
                        No Queries available
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </Card.Body>
        </Card>
      </Container>

      {/* Modal */}
      {isModalOpen && (
        <Modal show={isModalOpen} onHide={() => setIsModalOpen(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Reply to Request</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form onSubmit={handleFormSubmit}>
              <input id="task_uniqueid" className="form-control" type="hidden" value={selectedRequest?.ID || ''} readOnly />
              <input id="task_uniqueid" className="form-control" type="hidden" value={selectedRequest?.ID || ''} readOnly />
              <Form.Group className="mb-3">
                <Form.Label>Remarks</Form.Label>
                <Form.Control 
                  as="textarea" 
                  rows={3} 
                  value={user_Description} 
                  onChange={(e) => setUserRemarks(e.target.value)} 
                  required 
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Upload Files</Form.Label>
                <Form.Control 
                  type="file" 
                  onChange={(e) => setSelectedFiles([...e.target.files])} 
                  multiple 
                />
              </Form.Group>
              <Button type="submit" variant="primary" disabled={isSubmitting}>
                {isSubmitting ? 'Submitting...' : 'Submit Reply'}
              </Button>
            </Form>
          </Modal.Body>
        </Modal>
      )}
    </>
  );
};

export default UserQueries;
